import { MissionCardObject } from '@a_team/models/dist/MissionObject';

export const getIsMissionLiked = (
  missions: MissionCardObject[] | undefined,
  mid: string,
): boolean => {
  if (!missions) return false;
  return missions.some((mission) => mission.mid === mid);
};
